import _ from 'underscore';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import session from '@/models/v5/session';
import template from '@/../templates/login-verify.hbs';
var globalCh = Radio.channel('global');
/**
 * Call this function after we get successful call to signup_account.verify
 * It will save the token to localstorage and refresh the IDE
 */
function save_token_and_reload_ide(resp) {
    var err;
    var tokens = resp && resp.meta && resp.meta.tokens;
    var path_parts = ['', 'ide'];
    if (!tokens) {
        err = 'Couldn\'t find tokens after verifying';
        console.error(err);
        Radio.request('alerts', 'showAlert', {
            header: 'Error',
            message: 'There was an unexpected error. Try refreshing the browser and logging in with your new password.',
            messageType: 'danger'
        });
    }
    Radio.request('alerts', 'showAlert', {
        header: 'Success',
        message: "Logging in...",
        messageType: 'success'
    });
    // Set API key so the user doesn't have to login manually
    session.set({
        access_token: tokens.access_token,
        refresh_token: tokens.refresh_token,
        expires_at: tokens.expires_at
    });
    session.save();
    var from_invite = resp.meta && resp.meta.from_invite;
    var account_data = resp.data && resp.data.attributes;
    if (from_invite && account_data) {
        path_parts = path_parts.concat([account_data.username, 'collaborators', 'me']);
    }
    // Send the user to the full app
    window.location = path_parts.join('/');
}
export default Marionette.View.extend({
    template: Handlebars.compile(template),
    ui: {
        form: 'form',
        username: '#signup-username',
        password: '#signup-password',
        given_name: '#signup-given-name',
        family_name: '#signup-family-name',
        country: '#signup-country',
        passwordConfirm: '#signup-password-check',
        accept_terms: '.form-check-input',
        submit_btn: 'button[type=submit]',
    },
    // Note: debounced events are set up in onRender()
    events: {
        'submit form': 'onSubmit',
        'click #signup-button': 'returnToSignup',
        'click @ui.accept_terms': 'toggle_submit',
    },
    initialize: function(options) {
        this.validToken = options.validToken;
    },
    templateContext: function() {
        // Override the terms of service text if appropriate
        // (An empty string will hide the terms of service text entirely.)
        var useCustomTerms = false;
        var app_features = globalCh.request('app_options', 'features');
        var custom_copy = app_features && app_features.custom_copy;
        if (_.isString(custom_copy && custom_copy.terms)) {
            useCustomTerms = true;
        }
        var suggested_country = this.getOption('suggested_country');
        var valid_countries = this.getOption('valid_countries');
        var countries = [];
        /**
        * Given a suggested_country, return an object that has a 
        * String name a and Boolean indicating that this name was the
        * suggested one.
        *
        * Used for making an option list in the country pulldown
        */
        function country_name_to_obj(country_name) {
            return {
                name: country_name,
                selected: country_name == suggested_country
            };
        }
        if (valid_countries)
            countries = valid_countries.map(country_name_to_obj);
        return {
            countries: countries,
            useCustomTerms: useCustomTerms,
            customTerms: custom_copy && custom_copy.terms,
            noSignup: app_features && app_features.signup === false,
            initialLoad: false,
            validToken: this.validToken
        };
    },
    onRender: function() {
        this.ui.submit_btn.prop('disabled', true);
        // Set up debounced event handlers
        var debounceTime = 500;
        _.bindAll(this, 'hasValidUsername', 'hasValidPassword', 'hasValidPasswordConfirm');
        this.ui.username.on('input focusout', _.debounce(this.hasValidUsername, debounceTime));
        this.ui.password.on('input focusout', _.debounce(this.hasValidPassword, debounceTime));
        this.ui.passwordConfirm.on('input focusout', _.debounce(this.hasValidPasswordConfirm, debounceTime));
    },
    returnToSignup: function(e) {
        var globalCh = Radio.channel('global');
        globalCh.request('login');
    },
    showInputError: function(field, error) {
        field.siblings('.help-block').text(error);
        field.parent().addClass('has-error');
    },
    hideInputError: function(field) {
        field.siblings('.help-block').text('');
        field.parent().removeClass('has-error');
    },
    hasValidUsername: function() {
        var isValid = (this.ui.username.val().length >= 3 && this.ui.username.val().length <= 20);
        if (isValid) {
            this.hideInputError(this.ui.username);
        } else {
            this.showInputError(this.ui.username, 'Username must be between 3 and 20 characters.');
        }
        return isValid;
    },
    hasValidPassword: function() {
        var isValid = (this.ui.password.val().length >= 8);
        if (isValid) {
            this.hideInputError(this.ui.password);
        } else {
            this.showInputError(this.ui.password, 'Password must be at least 8 characters.');
        }
        return isValid;
    },
    hasValidPasswordConfirm: function() {
        var isValid = (this.ui.password.val() === this.ui.passwordConfirm.val());
        if (isValid) {
            this.hideInputError(this.ui.passwordConfirm);
        } else {
            this.showInputError(this.ui.passwordConfirm, 'Passwords must match.');
        }
        return isValid;
    },
    handle_submit_errors: function (resp) {
        // If the response doesn't look like it has any useful
        // information, show an alert and bug out
        if (!(resp && resp.responseJSON && resp.responseJSON.errors)) {
            console.error(resp);
            Radio.request('alerts', 'showAlert', {
                header: 'Error',
                message: 'Unknown error',
                messageType: 'danger'
            });
            return;
        }
        // Iterate through the error mesages. If we can associate the message
        // with a specific field, show the error near the field. Otherwise,
        // show an alert.
        var unhandled_errors = [];
        var attrs_field_re = new RegExp('/data/attributes/(\\w+)');
        var missing_field_re = new RegExp("was missing '([^']+)'");
        resp.responseJSON.errors.forEach((function(e) {
            // field validation error keys are either pointer or parameter 
            for (var prop in e.source) {
                var source_key = prop;
                break;
            }

            var ui_field;
            var err;
            var missing_field_err = e.detail.match(missing_field_re);
            var field_validation_err = e.source[source_key].match(attrs_field_re);

            if (missing_field_err) {
                ui_field = missing_field_err[1];
                err = 'Need to provide a ' + ui_field;
            } else if (field_validation_err) {
                ui_field = field_validation_err[1];
                err = e.detail;
            } else {
                unhandled_errors.push(e.title + ': ' + e.detail);
                return;
            }
            // Attempt to find the view's 
            try {
                this.showInputError(this.ui[ ui_field ], err);
            } catch (e) {
                console.error(e);
            }
        }).bind(this));
        // Show an alert for any errors we couldn't associate with a field
        if (unhandled_errors.length) {
            Radio.request('alerts', 'showAlert', {
                header: 'Error',
                message: unhandled_errors.join('<br>\n'),
                messageType: 'danger'
            });
        }
    },
    toggle_submit(e) {
        this.ui.submit_btn.prop('disabled', !this.ui.submit_btn.prop('disabled'));
    },
    onSubmit: function(event) {
        event.preventDefault();
        // Validate input fields
        var validUsername = this.hasValidUsername();
        var validPassword = this.hasValidPassword();
        var validPasswordConfirm = this.hasValidPasswordConfirm();
        if (!validUsername || !validPassword || !validPasswordConfirm) {
            return;
        }
        var signup_account = this.model;
        this.ui.form.serializeArray().forEach(function(field) {
            signup_account.set(field.name, field.value);
        });
        // Get country explicitly since serializeArray doesn't capture
        // the values of select elements
        signup_account.set('country', this.ui.country.val());
        signup_account.verify()
            .done(save_token_and_reload_ide)
            .fail(this.handle_submit_errors.bind(this))
        ;
    }
});

